import { render, staticRenderFns } from "./TelegramBotConnectionCard.vue?vue&type=template&id=cbeffc76"
import script from "./TelegramBotConnectionCard.vue?vue&type=script&lang=js"
export * from "./TelegramBotConnectionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports